document.querySelectorAll('[data-pawable-stats]').forEach(function (grid) {
  var counted = false;

  var animate = function () {
    if (counted) return;
    counted = true;

    grid.querySelectorAll('[data-count-to]').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-count-to')) || 0;
      var duration = 1200;
      var start = null;

      var step = function (timestamp) {
        if (start === null) start = timestamp;
        var progress = Math.min((timestamp - start) / duration, 1);
        var value = target * progress;
        el.textContent = Number.isInteger(target) ? Math.round(value) : value.toFixed(1);
        if (progress < 1) window.requestAnimationFrame(step);
      };

      window.requestAnimationFrame(step);
    });

    grid.querySelectorAll('[data-bar-pct]').forEach(function (bar) {
      var pct = Math.min(parseFloat(bar.getAttribute('data-bar-pct')) || 0, 100);
      bar.style.width = pct + '%';
    });
  };

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) animate();
        });
      },
      { threshold: 0.4 }
    );
    observer.observe(grid);
  } else {
    animate();
  }
});
